<div [ngClass]="{
  'closed-sidebar' : globals.toggleSidebar,
  'closed-sidebar-md' : globals.toggleSidebarMobile,
  'closed-sidebar-open': globals.sidebarHover || globals.toggleSidebarMobile,
  'header-menu-open' : globals.toggleHeaderMobile,
  'fixed-footer' : globals.toggleFixedFooter,
  'sidebar-collapsed': !globals.sidebarVisible
  }" [class]="'app-container app-theme-white'">
    <app-header></app-header>
    
    <div class="app-main__outer" 
         [style.padding-left]="globals.sidebarVisible ? '16.5%' : '80px'"
         style="padding-top: 5%; transition: padding-left 0.3s ease;">
      <div class="app-main__inner">
        <div [@architectUIAnimation]="o.isActivated ? o.activatedRoute : ''">
          <router-outlet #o="outlet"></router-outlet>
        </div>
      </div>
    </div>
    
    <div class="sidebar-menu-overlay" (click)="toggleSidebarMobile()"></div>
  </div>
  <ngx-loading-bar [color]="'var(--primary)'"></ngx-loading-bar>